var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageBox"},[_c('div',{staticClass:"page_box"},[_c('div',{attrs:{"id":"page_turn_box"}},_vm._l((_vm.pageBoxData),function(item,index){return _c('li',{key:index},[_c('router-link',{class:[
            _vm.pageIndex == item.Nab || (!_vm.pageIndex && item.Nab == 1) ? 'on' : ''
          ],attrs:{"to":item.Url}},[_vm._v(_vm._s(item.Name))])],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386d3554","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageBox.vue
// module id = null
// module chunks = 